import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { merge, Subject, Subscription } from "rxjs";
import {
  debounceTime,
  map,
  mergeAll,
  switchMap,
  takeUntil,
} from "rxjs/operators";
import { SessionService } from "src/app/session.service";
import { SignalsService, TemplateDTO } from "src/app/signals/signals.service";
import { ElementLoaderDirective } from "src/app/ui/element-loader/element-loader.directive";

@Component({
  selector: "app-signal-preview-dialog",
  templateUrl: "./signal-preview-dialog.component.html",
  styleUrls: ["./signal-preview-dialog.component.scss"],
})
export class SignalPreviewDialogComponent implements OnInit {
  type: string;
  content!: SafeHtml;
  contentSelected: boolean = false;
  pushNotificationSelected: boolean = true;
  heading: string;
  text: string;
  templateOptions: TemplateDTO[];
  @ViewChild(ElementLoaderDirective)
  elementLoader!: ElementLoaderDirective;
  templateControl: FormControl;
  headlineControl: FormControl;
  notificationControl: FormControl;
  contentControl: FormControl;
  feedbackControl: FormControl;
  redemptionControl: FormControl;
  signalChangeSub!: Subscription;
  private onComponentDestroy = new Subject();
  forAssistant: boolean = false;
  contentControlModel: string = "";

  constructor(
    private dialogRef: MatDialogRef<SignalPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: {
      type: string;
      preview: string;
      templateOptions: TemplateDTO[];
      templateControl: FormControl;
      headlineControl: FormControl;
      notificationControl: FormControl;
      contentControl: FormControl;
      feedbackControl: FormControl;
      redemptionControl: FormControl;
      forAssistant: boolean;
    },
    private SessionService: SessionService,
    private sanitizer: DomSanitizer,
    private SignalsService: SignalsService,
  ) {
    this.type = data.type;

    this.contentControlModel = data.contentControl.value;

    this.forAssistant = data.forAssistant;

    this.initPreview(data.preview);
    this.templateOptions = data.templateOptions;

    this.templateControl = data.templateControl;
    this.headlineControl = data.headlineControl;
    this.notificationControl = data.notificationControl;
    this.contentControl = data.contentControl;
    this.feedbackControl = data.feedbackControl;
    this.redemptionControl = data.redemptionControl;

    this.heading = this.headlineControl.value;
    this.text = this.notificationControl.value;
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.signalChangeSub = merge(
      this.templateControl.valueChanges,
      this.headlineControl.valueChanges,
      this.notificationControl.valueChanges,
      this.contentControl.valueChanges,
      this.feedbackControl.valueChanges,
      this.redemptionControl.valueChanges,
    )
      .pipe(
        map(() => {
          //this.heading = this.headlineControl.value;
          //this.text = this.notificationControl.value;
        }),
        debounceTime(300),
        switchMap(() =>
          this.elementLoader.waitForEvent(this.getSignalPreview()),
        ),
      )
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((preview) => {
        this.updatePreview(preview);
      });


    this.getSignalPreview().subscribe((preview) => {
      this.updatePreview(preview);
    });

  }

  ngOnDestroy() {
    this.signalChangeSub.unsubscribe();
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  updatePreview(data: any) {
    this.heading = data.headline;
    this.text = data.notification;
    this.initPreview(data.template);
  }

  initPreview(html: string, profile: any = null) {
    
    const blob = new Blob([html], { type: "text/html;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const iFrameBody =
      '<iframe seamless src="' +
      url +
      '" frameborder="0" scrolling="no" width="380" height="810" style="border-width: 0px; transform: scale(.7); transform-origin: top left"></iframe>';
    this.content = this.sanitizer.bypassSecurityTrustHtml(iFrameBody);
  }

  get currentApp() {
    return this.SessionService.currentAppValue!;
  }

  get previewDTO() {
    return {
      ...this.templateControl.value,
      has_feedback: this.feedbackControl.value,
      has_redemption: this.redemptionControl.value,
      headline: this.headlineControl.value,
      notification: this.notificationControl.value,
      content: this.contentControl.value,
    };
  }

  bodyContentChanged(event: any) {
    this.contentControl.setValue(event);
  }

  onContentSelected() {
    this.contentSelected = true;
    this.pushNotificationSelected = false;
  }

  onPushSelected() {
    this.pushNotificationSelected = true;
    this.contentSelected = false;
  }

  closePreview(result: any = false) {
    this.dialogRef.close(result);
  }

  getSignalPreview() {
    console.log('getSignalPreview');
    return this.SignalsService.getSignalPreview(
      this.SessionService.currentAccountValue!.accountID,
      this.previewDTO,
    );
  }
}
